import Image from "./../image";
import { useLanguageStore } from "../../store/languageStore";
import { LanguageType } from "../../types/language";
import { useAudioStore } from "@/store/audioStore";

interface SettingLanguageProps {
  text: string;
  languageType: LanguageType;
  onClick?: () => void;
}

const SettingLanguage: React.FC<SettingLanguageProps> = ({
  text,
  languageType,
  onClick,
}) => {
  const appLanguage = useLanguageStore((state) => state.appLanguage);
  const voiceLanguage = useLanguageStore((state) => state.voiceLanguage);
  const audioVoice = useAudioStore((s) => s.audioVoice);
  const selectedVoiceName = useLanguageStore((s) => s.selectedVoiceName);

  const getAppLanguageName = useLanguageStore(
    (state) => state.getAppLanguageName
  );
  const getVoiceLanguageName = useLanguageStore(
    (state) => state.getVoiceLanguageName
  );
  const getVoiceName = useAudioStore((s) => s.getVoiceName);

  const getDisplayName = () => {
    switch (languageType) {
      case "simulation":
        return getVoiceName(audioVoice);
      case "app":
        return getAppLanguageName(selectedLanguage);
      case "voiceLang":
        return getVoiceLanguageName(selectedLanguage);
      case "voice":
        return selectedVoiceName;
      default:
        return selectedLanguage;
    }
  };

  const selectedLanguage =
    languageType === "simulation"
      ? "simulation"
      : languageType === "app"
      ? appLanguage
      : voiceLanguage;

  const displayName = getDisplayName();

  return (
    <div
      className="flex items-center justify-between py-[13px] cursor-pointer"
      onClick={onClick}
    >
      <span className="text-400 primary-text-color">{text}</span>
      <div className="flex">
        <span className="text-400 pr-[12px primary-text-color">
          {displayName}
        </span>
        <Image
          aria-hidden
          src="/assets/icon_chevron_right.png"
          alt="icon"
          width={20}
          height={20}
        />
      </div>
    </div>
  );
};

export default SettingLanguage;
